<template>
	<div class="region-select">
		<el-cascader
			ref="refRegion"
			:value="value"
			:options="regionList"
			:props="regProp"
			v-bind="iptConf"
			@change="handleChange"
			size="small"
			filterable
      :disabled="!enabled"
		></el-cascader>
	</div>
</template>

<script>
import area from '../../support/area.json'

export default {
	name: 'RegionSelect',
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		/** 取值为： id/text */
		valueField: { type: String, default: 'id' },
		value: { type: Array, default:()=> [] },
    enabled: {type: Boolean, default: true }
	},
	data() {
		return {
			iptConf: {
				clearable: true,
				filterable: true,
			},
			regProp: {
				expandTrigger: 'hover',
				children: 'child',
				value: this.valueField,
				label: 'text',
        checkStrictly: true // 选择任意一级选项
			},
			regionList: [],
		};
	},
	mounted: function() {
    this.regionList = Object.freeze(area);
    // this.handleChange(this.value)
	},
	methods: {
		handleChange: function(val) {
			this.$emit('change', val, this.getCheckedDatas())
		},
		getCheckedDatas: function() {
			const datas = [];
			const selNode = this.$refs['refRegion'].getCheckedNodes()[0];
			if (!selNode) {
				return datas;
			}
			this.$refs['refRegion'].getCheckedNodes()[0].pathNodes.map(item => {
				datas.push({ id: item.data.id, text: item.data.text });
			});
			return datas;
		},
	},
};
</script>
<style>
.el-cascader-menu {
  height: 300px;
}
.el-cascader{
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/RegionSelect.vue